import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import AppLayout from "../pages/AppLayout";

function ProtectedRoute({ component: Component, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        user !== null ? (
          <AppLayout>
            <Component {...props} />
          </AppLayout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
}

const mapStateToProps = (state, ownProps) => ({
  user: state.session.user
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/rutas/ProtectedRoute.jsx